import React, { Component } from 'react';
import {
    Container, Row, Col, TabContent, TabPane, Nav, NavItem, NavLink,
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Input
} from 'reactstrap';
import Moment from 'react-moment';

import NumberFormat from 'react-number-format';
import { compose } from 'recompose';

import { withFirebase } from '../../components/Firebase';
import { withAuthorization } from '../../components/Session';

import * as ROUTES from '../../constants/routes';
import * as CHAVES from '../../constants/chaves';

import MenuAdm from '../../menu/menuAdm';

const INITIAL_STATE = {
    error: null,
    userAutenticado: {},
    usuarioLogado: {},
    loading: false,
    modal: false,
    modalTipo: 0,
    modalTitulo: "",
    modalMensagem: "",
    modalPagamento: false,
    profissionalEscolhido: {},
    activeTab: '1',
    solicitacoesEmAnalise: [],
    solicitacaoEscolhida: {},
    modelFeedback: false,
    modelFeedEstrelas: [],
    modelFeedComentario: '',
    modelFeedNestrelas: 3,
    solicitacoesFinalizadas: [],
    foto: "",
};

class MinhasSolicitacoesBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
        this.modal = this.modal.bind(this);
        this.alteraTab = this.alteraTab.bind(this);
        this.finalizarServico = this.finalizarServico.bind(this);
        this.cancelarServico = this.cancelarServico.bind(this);
        this.cancelar = this.cancelar.bind(this);
        this.proceder = this.proceder.bind(this);
        this.alterarEstrela = this.alterarEstrela.bind(this);
        this.onChange = this.onChange.bind(this);
        this.enviarFeedback = this.enviarFeedback.bind(this);
        this.pagamento = this.pagamento.bind(this);
        this.escolher = this.escolher.bind(this);
    }

    componentDidMount() {
        this.listenerUserAutenticado = this.props.firebase.auth.onAuthStateChanged(userAutenticado => {
            userAutenticado
                ? this.setState({
                    userAutenticado,
                    foto: userAutenticado.photoURL,
                })
                : this.setState({ userAutenticado: null });
        });

        this.props.firebase.solicitante(this.props.firebase.auth.currentUser.uid).once('value').then((snapshot) => {
            this.setState({
                usuarioLogado: snapshot.val(),
                foto: snapshot.val().url,
            });
        });

        // carrega solicitações em Analise
        this.props.firebase.chamadosPorSolicitanteEmAnalise()
            .child(this.props.firebase.auth.currentUser.uid).on('value', snapshot => {
                const solicitacoesEmAnaliseObject = snapshot.val();

                if (solicitacoesEmAnaliseObject) {
                    const solicitacoesEmAnaliseList = Object.keys(solicitacoesEmAnaliseObject).map(key => ({
                        ...solicitacoesEmAnaliseObject[key],
                        uid: key,
                    }));

                    this.setState({
                        solicitacoesEmAnalise: solicitacoesEmAnaliseList,
                        loading: false,
                        modelFeedEstrelas: ['/estrelaOK.png', '/estrelaOK.png', '/estrelaOK.png', '/estrelaCancel.png', '/estrelaCancel.png']
                    });
                }
            });

        // carrega solicitações finalizadas
        this.props.firebase.chamadosPorSolicitenteFinalizados()
            .child(this.props.firebase.auth.currentUser.uid).on('value', snapshot => {
                const solicitacoesFinalizadasObject = snapshot.val();

                if (solicitacoesFinalizadasObject) {
                    const solicitacoesFinalizadasList = Object.keys(solicitacoesFinalizadasObject).map(key => ({
                        ...solicitacoesFinalizadasObject[key],
                        uid: key,
                    }));

                    this.setState({
                        solicitacoesFinalizadas: solicitacoesFinalizadasList,
                    });
                }
            });
    }
    componentWillUnmount() {
        this.listenerUserAutenticado();
    }

    onChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    modal() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    alteraTab(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    cancelarServico = solicitacao => {
        // confirmar o cancelamento do serviço
        this.setState({
            modal: true,
            modalTitulo: "Cancelar Serviço ?",
            modalMensagem: `Você deseja cancelar o serviço com ${solicitacao.profissionalEscolhido.nome} e chamar outro profissional?`,
            modalTipo: 2,
            solicitacaoEscolhida: solicitacao,
        })
    }

    finalizarServico = soliciacao => {
        // confirmar a finalização do serviço
        this.setState({
            modal: true,
            modalTitulo: "Finalizar Serviço ?",
            modalMensagem: "O profissional concluiu o serviço?",
            modalTipo: 1,
            solicitacaoEscolhida: soliciacao,
        })
    }

    alterarEstrela = numero => {
        let n = numero;
        console.log(n);
        let modelFeedEstrelas = this.state.modelFeedEstrelas;
        var x
        for (x = 0; x < 5; x++) {
            modelFeedEstrelas[x] = '/estrelaCancel.png';
        }
        for (x = 0; x <= n; x++) {
            modelFeedEstrelas[x] = '/estrelaOK.png';
        }
        this.setState({
            modelFeedEstrelas,
            modelFeedNestrelas: n,
        })
    }

    cancelar() {
        this.setState({
            modal: false,
            modalTitulo: "",
            modalMensagem: "",
            modalTipo: 0,
        })
    }

    proceder() {

        //apagar as referencias atuais (Solicitante e Profissional)
        this.props.firebase.chamadosPorSolicitanteEmAndamento()
            .child(this.props.firebase.auth.currentUser.uid)
            .child(this.state.solicitacaoEscolhida.uid).set(null);

        this.props.firebase.chamadosPorProfissionalEmAndamento()
            .child(this.state.solicitacaoEscolhida.profissionalEscolhido.uid)
            .child(this.state.solicitacaoEscolhida.uid).set(null);

        // é finalização do serviço
        if (this.state.modalTipo === 1) {

            // colocar as referencias do serviço como FINALIZADO no solicitante

            let soliciacao = this.state.solicitacaoEscolhida;
            soliciacao.dataHoraFinalizado = new Date().getTime();
            soliciacao.status = CHAVES.CHAMADOS_FINALIZADOS_POR_SOLICITANTE;
            this.props.firebase.chamadosPorSolicitenteFinalizados()
                .child(this.props.firebase.auth.currentUser.uid)
                .child(this.state.solicitacaoEscolhida.uid).set(soliciacao);

            // colocar as referencias como serviços finalizados no profissional
            soliciacao.status = CHAVES.CHAMADOS_FINALIZADOS_POR_PROFISSIONAL;
            this.props.firebase.chamadosPorProfissionalFinalizados()
                .child(this.state.solicitacaoEscolhida.profissionalEscolhido.uid)
                .child(this.state.solicitacaoEscolhida.uid).set(soliciacao);

            // solicitar a coleta de feedback 
            this.setState({
                modelFeedback: true,
            })
        }
        // é cancelamento do Serviço com esse profissional 
        if (this.state.modalTipo === 2) {

            // colocar as referencias do serviço como em Aberto
            let soliciacao = this.state.solicitacaoEscolhida;

            console.log(JSON.stringify(soliciacao));
            soliciacao.status = CHAVES.CHAMADOS_POR_SOLICITANTE_EM_ABERTO;
            this.props.firebase.chamadosPorSolicitanteEmAberto()
                .child(this.props.firebase.auth.currentUser.uid)
                .child(soliciacao.uid).set(soliciacao);


            // redirecionar para selecionarProfissional
            this.props.history.push(ROUTES.ESCOLHER_PROFISSIONAL);
        }

    }

    enviarFeedback() {
        // atualiza informações do perfil 
        let profissionalEscolhido = this.state.solicitacaoEscolhida.profissionalEscolhido;
        let { nAvaliacoes, media } = profissionalEscolhido.curriculo;

        try {
            media = ((media * nAvaliacoes) + this.state.modelFeedNestrelas) / (nAvaliacoes + 1);

        } catch (err) {
            media = this.state.modelFeedNestrelas;

        }
        profissionalEscolhido.curriculo.media = media;
        profissionalEscolhido.curriculo.nAvaliacoes++;
        try {
            profissionalEscolhido.curriculo.comentarios.push(this.state.modelFeedComentario);
        } catch (err) {
            profissionalEscolhido.curriculo.comentarios = [];
            profissionalEscolhido.curriculo.comentarios.push(this.state.modelFeedComentario);
        }

        console.log(profissionalEscolhido);

        // salvar informaçoes no perfil do profissional 
        this.props.firebase.profissionais()
            .child(profissionalEscolhido.uid)
            .set(profissionalEscolhido);

        // salvar informações nos perfils dos profissionais por cidade
        profissionalEscolhido.areasDeAtuacao.map(area => {
            this.props.firebase.profissionaisPorCidadePorAreaAtuacao()
                .child(profissionalEscolhido.uidCidade)
                .child(area.uid)
                .child(profissionalEscolhido.uid)
                .set(profissionalEscolhido);
        });

        this.setState({
            activeTab: `2`,
            modelFeedback: false,
            modal: false,
        });
    }

    escolher = () => {
        this.setState({
            modalPagamento: false,
            activeTab: 2,
        });
    }

    pagamento = prof => {
        this.setState({
            modalPagamento: true,
            profissionalEscolhido: prof,
        })
    }

    render() {

        const {
            userAutenticado, activeTab, solicitacoesEmAnalise, solicitacoesFinalizadas,
            modal, modalTitulo, modalMensagem,
            modelFeedback, modelFeedComentario, modelFeedEstrelas,
            modalPagamento, profissionalEscolhido, foto } = this.state;

        return (
            <div>
                <MenuAdm />
                <header className="masthead">
                    <div className="container h-100">
                        <div className="divBranca">
                            {modalPagamento &&
                                <div>
                                    <Modal isOpen={this.state.modalPagamento} toggle={this.toggle} className={this.props.className}>
                                        <ModalHeader toggle={this.toggle}>Indisponibilidade temporária do Serviço </ModalHeader>
                                        <ModalBody>
                                            <p>Por algum motivo o serviço de pagamento encontra-se off-line neste momento</p>
                                            <p>Entre em contato conosco pelo whatsapp para efetuar o seu pagamento</p>
                                        </ModalBody>
                                        <ModalFooter>
                                            <a target="_blank" href={"https://api.whatsapp.com/send?phone=5586981817123&text=Desejo%20realizar%20o%20pagamento%20para%20o%20profissional%20" + profissionalEscolhido.nome}>
                                                <Button color="success" onClick={this.escolher} >Contato pelo whatsapp</Button>
                                            </a>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            }
                            {modal &&
                                <div>
                                    <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                                        <ModalHeader toggle={this.toggle}>{modalTitulo} </ModalHeader>
                                        <ModalBody>{modalMensagem}</ModalBody>
                                        <ModalFooter>
                                            <Button color="secondary" onClick={this.cancelar}>Não</Button>
                                            <Button color="success" onClick={this.proceder}>Sim</Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            }
                            {modelFeedback &&
                                <div>
                                    <Modal isOpen={this.state.modelFeedback} toggle={this.toggle} className={this.props.className}>
                                        <ModalHeader toggle={this.toggle}>Avalie o seu atendimento</ModalHeader>
                                        <ModalBody>
                                            <p>Esse profissional merece quantas estrelas</p>
                                            {
                                                <div>
                                                    <img src={process.env.PUBLIC_URL + modelFeedEstrelas[0]} onClick={() => this.alterarEstrela('0')} alt='' width="30" />
                                                    <img src={process.env.PUBLIC_URL + modelFeedEstrelas[1]} onClick={() => this.alterarEstrela('1')} alt='' width="30" />
                                                    <img src={process.env.PUBLIC_URL + modelFeedEstrelas[2]} onClick={() => this.alterarEstrela('2')} alt='' width="30" />
                                                    <img src={process.env.PUBLIC_URL + modelFeedEstrelas[3]} onClick={() => this.alterarEstrela('3')} alt='' width="30" />
                                                    <img src={process.env.PUBLIC_URL + modelFeedEstrelas[4]} onClick={() => this.alterarEstrela('4')} alt='' width="30" />
                                                </div>
                                            }
                                            <hr />
                                            <p> Você deseja fazer algum comentário sobre o seu antendimento? ou sobre o profissional ?</p>
                                            <Input type='textarea' value={modelFeedComentario} name="modelFeedComentario" onChange={this.onChange}></Input>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="success" onClick={this.enviarFeedback}>Concluir</Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            }
                            <Row>
                                <Col>
                                    <h3><img src={foto} width='50' alt='img usuario' /> {userAutenticado.displayName} - {}</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Nav tabs>
                                        <NavItem>
                                            <NavLink
                                                onClick={() => { this.alteraTab('1'); }}
                                                className={{ active: activeTab == "1" }}> Solicitações em Analise </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                onClick={() => { this.alteraTab('2'); }}
                                                className={{ active: activeTab == "2" }}> Solicitações em Andamento </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                onClick={() => { this.alteraTab('3'); }}
                                                className={{ active: activeTab == "3" }}  > Solicitações Atendidas </NavLink>
                                        </NavItem>
                                    </Nav>
                                    <TabContent activeTab={this.state.activeTab}>
                                        <TabPane tabId="1">
                                            <Row>
                                                <Col>

                                                    {
                                                        solicitacoesEmAnalise == [] &&
                                                        <div class="card">
                                                            <div class="card-header">
                                                                Vazio
                                                        </div>
                                                            <div class="card-body">
                                                                <p class="card-text">Você não possui solicitações em Andamento</p>
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        solicitacoesEmAnalise.map(solicitacao => (
                                                            <div className="card">
                                                                <div className="card-header" id="headingOne">
                                                                    <h5 className="text-info">Solicitação - {solicitacao.areaDeAtuacao.nome} em <Moment format="DD/MM/YY HH:MM">{new Date(solicitacao.dataHora).getTime()}</Moment> </h5>
                                                                </div>
                                                                {
                                                                    solicitacao.profissionais_selecionados.map(prof => (
                                                                        <div>
                                                                            <div className="card">
                                                                                <Row>
                                                                                    <Col xs="2" className="text-center">
                                                                                        <img src={process.env.PUBLIC_URL + 'img/iconeuser.png'} width='50' alt='' />
                                                                                    </Col>
                                                                                    <Col xs="10">
                                                                                        <p> {prof.nome} {prof.sobrenome}</p>
                                                                                        <h4>
                                                                                            ({prof.telefone.substring(3, 5)}) {prof.telefone.substring(5, 10)}-{prof.telefone.substring(10, 14)}
                                                                                        </h4>
                                                                                        <p> <i><b>Trabalha com: </b></i>
                                                                                            {
                                                                                                prof.areasDeAtuacao.map(area => (
                                                                                                    <span>{area.nome}, </span>
                                                                                                ))
                                                                                            }
                                                                                        </p>
                                                                                        <p>{prof.bairro} - {prof.cidade}</p>
                                                                                        {
                                                                                            prof.curriculo &&
                                                                                            (
                                                                                                <div>
                                                                                                    <p>{2019 - prof.curriculo.anoInicioProfissao} anos de profissão</p>
                                                                                                    <p>
                                                                                                        {
                                                                                                            prof.curriculo.comentarios &&
                                                                                                            (
                                                                                                                <p> <b>Comentários: </b> <br />{
                                                                                                                    prof.curriculo.comentarios.map(coment => (
                                                                                                                        <span>{coment}<br /></span>
                                                                                                                    ))
                                                                                                                }</p>
                                                                                                            )
                                                                                                        }
                                                                                                    </p>
                                                                                                </div>
                                                                                            )
                                                                                        }
                                                                                        {
                                                                                            solicitacao.orcamentos && (


                                                                                                solicitacao.orcamentos.map(orc => (
                                                                                                    <div>
                                                                                                        {
                                                                                                            orc.profissional.uid == prof.uid &&
                                                                                                            (
                                                                                                                <div>
                                                                                                                    <h4>Orçamento enviado</h4>
                                                                                                                    <table>
                                                                                                                        <tr>
                                                                                                                            <td>Valor da Mão de Obra</td>
                                                                                                                            <td className="text-right">{orc.valorMaoDeObra.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                                                                                        </tr>
                                                                                                                        <tr>
                                                                                                                            <td>Valor Orçado do Material</td>
                                                                                                                            <td className="text-right">{orc.valorMaterial.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                                                                                        </tr>
                                                                                                                        <tr>
                                                                                                                            <td>Valor Total</td>
                                                                                                                            <td className="text-right">{orc.valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                                                                                        </tr>
                                                                                                                        <tr>
                                                                                                                            <td></td>
                                                                                                                            <td>
                                                                                                                                <Button size="lg" onClick={() => this.pagamento(prof)} block type="submit" color="success"> Aprovar </Button>
                                                                                                                            </td>
                                                                                                                        </tr>
                                                                                                                    </table>

                                                                                                                </div>
                                                                                                            )
                                                                                                        }
                                                                                                    </div>

                                                                                                ))
                                                                                            )
                                                                                        }
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        ))
                                                    }

                                                </Col>
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <Row>
                                                <Col>
                                                    {solicitacoesFinalizadas.map(finalizada => (
                                                        <div className="card">
                                                            <div className="card-header" id="headingOne">
                                                                <h5 className="text-info">{finalizada.areaDeAtuacao.nome} finalizado em <Moment format="DD/MM/YY HH:MM">{new Date(finalizada.dataHoraFinalizado).getTime()}</Moment></h5>
                                                            </div>

                                                            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                                                <div className="card-body">
                                                                    <p> <b>Descrição do serviço solicitado</b>
                                                                        <ul>
                                                                            {finalizada.posts.map(post => (
                                                                                <li>{post.texto}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </p>
                                                                    <p>Profissional que realizou o atendimento: <b> {finalizada.profissionalEscolhido.nome} {finalizada.profissionalEscolhido.sobrenome} </b></p>
                                                                    <p>Telefone contato:
                                                                <b>({finalizada.profissionalEscolhido.telefone.substring(3, 5)}) {finalizada.profissionalEscolhido.telefone.substring(5, 10)}-{finalizada.profissionalEscolhido.telefone.substring(10, 14)}</b>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                    }

                                                </Col>
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <Row>
                                                <Col>
                                                    {solicitacoesFinalizadas.map(finalizada => (
                                                        <div className="card">
                                                            <div className="card-header" id="headingOne">
                                                                <h5 className="text-info">{finalizada.areaDeAtuacao.nome} finalizado em <Moment format="DD/MM/YY HH:MM">{new Date(finalizada.dataHoraFinalizado).getTime()}</Moment></h5>
                                                            </div>

                                                            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                                                <div className="card-body">
                                                                    <p> <b>Descrição do serviço solicitado</b>
                                                                        <ul>
                                                                            {finalizada.posts.map(post => (
                                                                                <li>{post.texto}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </p>
                                                                    <p>Profissional que realizou o atendimento: <b> {finalizada.profissionalEscolhido.nome} {finalizada.profissionalEscolhido.sobrenome} </b></p>
                                                                    <p>Telefone contato:
                                                                <b>({finalizada.profissionalEscolhido.telefone.substring(3, 5)}) {finalizada.profissionalEscolhido.telefone.substring(5, 10)}-{finalizada.profissionalEscolhido.telefone.substring(10, 14)}</b>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                    }

                                                </Col>
                                            </Row>
                                        </TabPane>
                                    </TabContent>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </header>
            </div>


        )
    }
}

const condition = authUser => !!authUser;

const MinhasSolicitacoes = compose(
    withFirebase,
    withAuthorization(condition),
)(MinhasSolicitacoesBase);

export default MinhasSolicitacoes;